import { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { Spinner } from "react-bootstrap";
import { commitOrder, startOrder } from "../ducks/shoppingCartSlice";

function SuccessPopup({ show, code, onClose }) {
  useEffect(() => {
    if (show) {
      const closeTimer = setTimeout(onClose, 2000);
      return () => clearTimeout(closeTimer);
    }
  }, [show, onClose]);

  if (!show) return null;

  const showLoading = /^\d+$/.test(code);

  return (
    <div
      style={{
        position: "fixed",
        textAlign: "center",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        color: "white",
        borderRadius: "10px",
        fontSize: "48px",
        zIndex: 10000,
        pointerEvents: "none",
      }}
    >
      {code}
      {showLoading && (
        <div className="d-flex justify-content-center w-100">
          <Spinner animation="grow" />
        </div>
      )}
    </div>
  );
}

export default function BarcodeScanner() {
  const dispatch = useDispatch();
  const [scannedCode, setScannedCode] = useState("");
  const barcodeBuffer = useRef("");
  const bufferTimeoutRef = useRef(null);
  const lastKeypressTime = useRef(0);
  // const SCANNER_THRESHOLD = 30; // ms entre teclas (scanners são muito rápidos)

  const { kilogramStep } = useSelector((state) => state.shop);
  const { items: products } = useSelector((state) => state.products);

  const addProductByCode = useCallback(
    async (code) => {
      const prod = products.find((i) => i.code === code);
      if (prod) {
        const uuid = uuidv4();
        await dispatch(startOrder({ uuid, productId: prod.id, kilogramStep }));
        await dispatch(commitOrder({ uuid }));
        setScannedCode("✅ Produto adicionado!");
        return;
      }

      setScannedCode(`❌ ${code} Código de barras não encontrado!`);
    },
    [dispatch, kilogramStep, products],
  );

  useEffect(() => {
    const handleKeyPress = (e) => {
      // Ignora teclas de controle
      if (e.key === "Shift" || e.key === "Control" || e.key === "Alt") {
        return;
      }

      // const currentTime = Date.now();
      // const timeDiff = currentTime - lastKeypressTime.current;

      // Verifica se a velocidade é de um scanner ou digitação manual
      // if (timeDiff > SCANNER_THRESHOLD && barcodeBuffer.current.length > 0) {
      //   isFromScanner.current = false; // Muito lento, provavelmente digitação manual
      // }

      // Se passou muito tempo, limpa o buffer (nova tentativa)
      // if (timeDiff > 1000) {
      //   barcodeBuffer.current = "";
      // }

      lastKeypressTime.current = Date.now();

      if (e.key === "Enter") {
        e.preventDefault();
        clearTimeout(bufferTimeoutRef.current);

        // Verifica se é um código válido (mínimo de caracteres)
        if (barcodeBuffer.current.length >= 1) {
          setScannedCode(barcodeBuffer.current);
          setTimeout(addProductByCode, 1000, barcodeBuffer.current);

          // addProductByCode(barcodeBuffer.current);
        }

        barcodeBuffer.current = "";
        return;
      }

      // Acumula caracteres
      if (e.key.length === 1) {
        barcodeBuffer.current += e.key;

        // Limpa o timeout anterior
        clearTimeout(bufferTimeoutRef.current);

        // Cria novo timeout de 500ms
        bufferTimeoutRef.current = setTimeout(() => {
          barcodeBuffer.current = "";
          setScannedCode("");
        }, 500);

        setScannedCode(barcodeBuffer.current);
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [addProductByCode]);

  return (
    <SuccessPopup
      show={!!scannedCode}
      code={scannedCode}
      onClose={() => setScannedCode("")}
    />
  );
}
